import React from 'react';
import styled from 'styled-components';
import { Colors } from '@prezi/dragon';
import Typography from '../Typography';

type Props = {
    error: boolean;
    children: any;
};

const Caption = styled(Typography)<{ error: boolean }>`
    display: block;
    color: ${p => (p.error ? Colors.red400 : 'inherit')};
    text-align: right;
    width: 100%;
    font-size: 0.8em;
    min-height: 1em;
`;

const InputCaption = ({ error, children }: Props) => {
    return (
        <Caption type="span" theme="caption" error={error}>
            {children}
        </Caption>
    );
};

export default InputCaption;
